/* 游民落地页「Your Portable Workstation」的滚动叙事。
 *
 * 本节被钉住（见 CSS 里 .workstation-pin > .workstation 的 sticky），滚动位置决定显示
 * 第几张图：刚进本节时是第 1 张，每往下滚一个本节高换下一张，最后一张过完本节才被放走，
 * 后面的块才进得来。读的是真实滚动位置，所以右侧滚动条直接拖、键盘翻页、手机惯性滚动
 * 都一样管用，不劫持滚轮。
 *
 * 钉住靠高度：脚本把外层 .workstation-pin 撑成「本节高 + (帧数-1) 个步长」，本节在里头
 * sticky。高度只由脚本加——禁用 JS 时容器高度等于内容，本节就是个静态的第 1 帧（初始
 * 选中态写在 Liquid 里，第 1 帧）。
 *
 * 设计稿这块没画任何控件，切换入口只有滚动本身：原先的三套手势（触屏滑 / 鼠标拖 /
 * 键盘 ←→）用户 2026-10-16 明确去掉了，只留滚动驱动。所以这里没有任何指针或键盘监听，
 * 桌面、平板、手机走的是同一条路——真实滚动位置；手机上惯性滚动也照样逐帧切换。
 *
 * 切帧动的是轨道的 translateX；轨道上只有真实帧，没有复制帧（不再无缝循环），所以帧号
 * 直接就是轨道位置。is-active / aria-hidden 沿用改成滚动叙事之前那套口径。
 */
(function () {
  'use strict';

  var SECTIONS_PER_FRAME = 1;   // 每换一张图要滚几个「本节高」——想改手感就改这一个数

  function init(root) {
    /* 容器在 Liquid 里，脚本是单独的 asset：两边的版本可能对不上（资源被缓存住），
       pin 或轨道找不到就静默退出，本节退回静态的第 1 帧，别在后面炸掉整页脚本。 */
    var pin = root.parentNode;
    if (!pin || !pin.hasAttribute || !pin.hasAttribute('data-starole-nomad-workstation-pin')) return;

    var track = root.querySelector('[data-starole-nomad-workstation-track]');
    var slides = root.querySelectorAll('[data-starole-nomad-workstation-slide]');
    if (!track || slides.length < 2) return;

    var current = 0;                  // 当前帧号；初值 0 与 Liquid 里第 1 帧的选中态对齐
    var stickTop = 0;                 // 本节 sticky 后停在视口哪条线上，写进 style.top
    var step = 1;                     // 相邻两帧之间的滚动距离
    var range = 1;                    // 进度 0→1 的滚动距离 = (帧数-1) × step
    var applied = pin.offsetHeight;   // 已写进 pin.style.height 的值，用来算高度增量

    /* header 是 sticky 的（sections/header-group.json 里 sticky_header: true，样式在
       section-header.css），钉在视口顶上会被它盖住。量它下沿，贴到它下面去；不是 sticky
       就返回 0，当没有。 */
    function headerOffset() {
      var header = document.querySelector('.site-header--sticky');
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }

    function layout() {
      var viewport = window.innerHeight;
      var section = root.offsetHeight;

      /* 视口放得下就整个露在 header 下面（贴 header 下沿），放不下就顶对齐。顶对齐时
         本节底部会切到视口外面，切掉的是本节底部那 9.976rem 的空白 padding，内容不丢。

         底对齐（top 取 viewport - section 这个负值）看着更「完整」，但会把标题上方那
         8.959rem 的 padding 顶出视口——视口比本节矮多少，标题就往上跑多少，最后直接贴
         在视口顶上。所以把底对齐夹在 0 以上：宁可切底部那截空白，也不留一个贴顶的标题。 */
      stickTop = Math.min(headerOffset(), Math.max(0, viewport - section));
      /* 步长跟着本节高走而不是视口高：整节是按 1rem=10px 与 vw 缩放写的，窄屏上本节
         会缩到两百来 px，用视口做步长就成了「一大片空白配一小块内容」。1920×1080 下
         本节高 1080，两者本来就相等。 */
      step = Math.max(1, Math.round(section * SECTIONS_PER_FRAME));
      range = (slides.length - 1) * step;

      var height = section + range;
      var grew = height - applied;

      /* 容器长高会把本节之后的内容整体顶下去：已经滚过本节的人（刷新时停在页尾那种）
         按增量补回同样的距离，看到的画面才不动。人停在本节钉住的那段行程里时不补。 */
      if (applied > 0 && grew !== 0) {
        var pinTop = pin.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > pinTop + applied) window.scrollBy(0, grew);
      }
      applied = height;

      root.style.top = stickTop + 'px';
      pin.style.height = height + 'px';
    }

    function show(index) {
      if (index === current) return;

      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');

      current = index;

      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');

      track.style.transform = 'translateX(' + (-100 * index) + '%)';
    }

    /* 进度不看「滚了多远」，看容器的顶边被滚到哪：本节开始钉住时容器顶边正好走到
       stickTop，钉住的行程就是 range，于是 stickTop - 容器顶边 直接就是已走的距离。
       这样量不必缓存基准点，上方内容（图片落位）高度变了也不用重算。 */
    function frameOf() {
      var progress = (stickTop - pin.getBoundingClientRect().top) / range;

      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      return Math.round(progress * (slides.length - 1));
    }

    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        show(frameOf());
      });
    }

    var resizing = false;
    function relayout() {
      if (resizing) return;
      resizing = true;
      window.requestAnimationFrame(function () {
        resizing = false;
        layout();
        show(frameOf());
      });
    }

    layout();
    show(frameOf());

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', relayout);
    /* 字体与图片落位后本节高度可能差几 px，重新量一次 */
    window.addEventListener('load', relayout);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-starole-nomad-workstation]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
